export const skillsSk = {
  skillCategories: {
    programming: 'Programovanie',
    web_development: 'Webový vývoj',
    backend: 'Backend vývoj',
    database: 'Databáza',
    devops: 'DevOps & Cloud',
    mobile: 'Mobilný vývoj',
    design: 'Design & Kreatíva',
    office: 'Kancelária & Administratíva',
    project_management: 'Projektové riadenie',
    data_science: 'Dátová veda & Analytika',
    marketing: 'Marketing & Reklama',
    sales: 'Predaj & Obchodný rozvoj',
    soft_skills: 'Mäkké zručnosti',
    finance: 'Financie & Účtovníctvo',
    healthcare: 'Zdravotníctvo',
    logistics: 'Logistika & Dodávateľský reťazec',
    manufacturing: 'Výroba & Produkcia',
    electrical: 'Elektrotechnika & Elektronika',
    automotive: 'Automobilový priemysel',
    construction: 'Stavebníctvo & Výstavba',
    agriculture: 'Poľnohospodárstvo & Farmárstvo',
    hospitality: 'Pohostinstvo & Cestovný ruch',
    legal: 'Právne & Právo',
    education: 'Vzdelávanie & Učenie',
    environment: 'Životné prostredie & Udržateľnosť',
    quality_management: 'Riadenie kvality',
    hr: 'Ľudské zdroje',
    safety: 'Bezpečnosť & Súlad',
    other: 'Ostatné',
  },
  skills: {
    // Existujúce zručnosti
    ms_word: 'Microsoft Word',
    ms_excel: 'Microsoft Excel',
    ms_powerpoint: 'Microsoft PowerPoint',
    autodesk: 'AutoDesk',
    corel_draw: 'Corel Draw',
    canva: 'Canva',
    adobe: 'Adobe',
    sap: 'SAP',
    salesforce: 'Salesforce',
    trello: 'Trello',
    angular: 'Angular',
    blockchain: 'Blockchain',
    c: 'C',
    cpp: 'C++',
    csharp: 'C#',
    java: 'Java',
    python: 'Python',
    ios: 'iOS',
    dotnet: '.NET',
    php: 'PHP',
    plc: 'PLC programovanie',

    // Programovacie jazyky
    javascript: 'JavaScript',
    typescript: 'TypeScript',
    golang: 'Go (Golang)',
    rust: 'Rust',
    ruby: 'Ruby',
    kotlin: 'Kotlin',
    swift: 'Swift',
    scala: 'Scala',
    r_language: 'R',
    perl: 'Perl',
    dart: 'Dart',
    elixir: 'Elixir',
    haskell: 'Haskell',
    assembly: 'Assembly',
    matlab: 'MATLAB',

    // Webový vývoj
    react: 'React',
    vuejs: 'Vue.js',
    nextjs: 'Next.js',
    nuxtjs: 'Nuxt.js',
    svelte: 'Svelte',
    html5: 'HTML5',
    css3: 'CSS3',
    sass: 'Sass/SCSS',
    tailwind: 'Tailwind CSS',
    bootstrap: 'Bootstrap',
    material_ui: 'Material UI',
    jquery: 'jQuery',
    webpack: 'Webpack',
    vite: 'Vite',
    redux: 'Redux',
    graphql: 'GraphQL',
    rest_api: 'REST API',
    websockets: 'WebSockets',

    // Backend
    nodejs: 'Node.js',
    expressjs: 'Express.js',
    django: 'Django',
    flask: 'Flask',
    fastapi: 'FastAPI',
    spring_boot: 'Spring Boot',
    laravel: 'Laravel',
    ruby_on_rails: 'Ruby on Rails',
    aspnet_core: 'ASP.NET Core',
    gin_go: 'Gin (Go)',
    nestjs: 'NestJS',
    symfony: 'Symfony',
    codeigniter: 'CodeIgniter',

    // Databáza
    postgresql: 'PostgreSQL',
    mysql: 'MySQL',
    mongodb: 'MongoDB',
    redis: 'Redis',
    elasticsearch: 'Elasticsearch',
    sqlite: 'SQLite',
    mariadb: 'MariaDB',
    mssql: 'Microsoft SQL Server',
    oracle_db: 'Oracle Database',
    dynamodb: 'DynamoDB',
    cassandra: 'Cassandra',
    couchdb: 'CouchDB',
    firebase: 'Firebase',
    supabase: 'Supabase',
    neo4j: 'Neo4j',

    // DevOps
    docker: 'Docker',
    kubernetes: 'Kubernetes',
    aws: 'AWS (Amazon Web Services)',
    azure: 'Microsoft Azure',
    gcp: 'Google Cloud Platform',
    terraform: 'Terraform',
    ansible: 'Ansible',
    jenkins: 'Jenkins',
    gitlab_cicd: 'GitLab CI/CD',
    github_actions: 'GitHub Actions',
    circleci: 'CircleCI',
    git: 'Git',
    linux: 'Linux',
    nginx: 'Nginx',
    apache: 'Apache',
    prometheus: 'Prometheus',
    grafana: 'Grafana',
    elk_stack: 'ELK Stack',

    // Mobilný
    react_native: 'React Native',
    flutter: 'Flutter',
    android: 'Vývoj pre Android',
    ios_dev: 'Vývoj pre iOS',
    swiftui: 'SwiftUI',
    jetpack_compose: 'Jetpack Compose',
    xamarin: 'Xamarin',
    ionic: 'Ionic',
    cordova: 'Cordova',

    // Design
    figma: 'Figma',
    photoshop: 'Adobe Photoshop',
    illustrator: 'Adobe Illustrator',
    adobe_xd: 'Adobe XD',
    indesign: 'Adobe InDesign',
    premiere_pro: 'Adobe Premiere Pro',
    after_effects: 'Adobe After Effects',
    sketch: 'Sketch',
    invision: 'InVision',
    ui_ux_design: 'UI/UX Design',
    graphic_design: 'Grafický dizajn',
    video_editing: 'Strih videa',
    '3d_modeling': '3D modelovanie',
    blender: 'Blender',
    cinema_4d: 'Cinema 4D',
    procreate: 'Procreate',

    // Kancelária
    ms_office: 'Microsoft Office Suite',
    google_workspace: 'Google Workspace',
    excel_advanced: 'Excel pokročilý',
    data_entry: 'Zadávanie údajov',
    data_analysis: 'Analýza dát',
    typing_speed: 'Rýchlosť písania',
    admin_support: 'Administratívna podpora',
    document_management: 'Správa dokumentov',

    // Projektové riadenie
    agile: 'Agile',
    scrum: 'Scrum',
    kanban: 'Kanban',
    jira: 'Jira',
    asana: 'Asana',
    monday: 'Monday.com',
    ms_project: 'Microsoft Project',
    confluence: 'Confluence',
    notion: 'Notion',
    basecamp: 'Basecamp',

    // Dátová veda
    machine_learning: 'Strojové učenie',
    deep_learning: 'Hlboké učenie',
    tensorflow: 'TensorFlow',
    pytorch: 'PyTorch',
    pandas: 'Pandas',
    numpy: 'NumPy',
    scikit_learn: 'Scikit-learn',
    nlp: 'Spracovanie prirodzeného jazyka (NLP)',
    computer_vision: 'Počítačové videnie',
    data_visualization: 'Vizualizácia dát',
    tableau: 'Tableau',
    power_bi: 'Power BI',
    jupyter: 'Jupyter Notebooks',
    statistics: 'Štatistika',
    ab_testing: 'A/B testovanie',

    // Marketing
    seo: 'SEO (Optimalizácia pre vyhľadávače)',
    sem: 'SEM (Marketing vo vyhľadávačoch)',
    google_ads: 'Google Ads',
    facebook_ads: 'Facebook Ads',
    social_media_marketing: 'Marketing na sociálnych sieťach',
    content_marketing: 'Obsahový marketing',
    email_marketing: 'E-mailový marketing',
    copywriting: 'Copywriting',
    google_analytics: 'Google Analytics',
    marketing_automation: 'Marketingová automatizácia',
    hubspot: 'HubSpot',
    mailchimp: 'Mailchimp',
    brand_management: 'Správa značky',
    influencer_marketing: 'Influencer marketing',

    // Predaj
    crm_systems: 'CRM systémy',
    cold_calling: 'Studené volanie',
    lead_generation: 'Generovanie leadov',
    negotiation: 'Vyjednávanie',
    sales_pipeline: 'Správa predajného reťazca',
    b2b_sales: 'B2B predaj',
    b2c_sales: 'B2C predaj',
    account_management: 'Správa účtov',
    customer_relationship: 'Riadenie vzťahov so zákazníkmi',
    sales_presentations: 'Predajné prezentácie',

    // Mäkké zručnosti
    leadership: 'Vedenie',
    team_management: 'Riadenie tímu',
    communication: 'Komunikácia',
    public_speaking: 'Verejné vystupovanie',
    presentation_skills: 'Prezentačné zručnosti',
    problem_solving: 'Riešenie problémov',
    critical_thinking: 'Kritické myslenie',
    time_management: 'Riadenie času',
    organization: 'Organizácia',
    teamwork: 'Tímová práca',
    collaboration: 'Spolupráca',
    adaptability: 'Adaptabilita',
    creativity: 'Kreativita',
    conflict_resolution: 'Riešenie konfliktov',
    decision_making: 'Rozhodovanie',
    emotional_intelligence: 'Emocionálna inteligencia',
    work_ethic: 'Pracovná morálka',
    attention_to_detail: 'Pozornosť na detail',

    // Financie
    accounting: 'Účtovníctvo',
    financial_analysis: 'Finančná analýza',
    bookkeeping: 'Vedenie účtovníctva',
    quickbooks: 'QuickBooks',
    xero: 'Xero',
    tax_preparation: 'Príprava daní',
    budgeting: 'Rozpočtovanie',
    financial_reporting: 'Finančné výkazníctvo',
    auditing: 'Audit',
    payroll: 'Spracovanie miezd',

    // Zdravotníctvo
    medical_terminology: 'Lekárska terminológia',
    patient_care: 'Starostlivosť o pacientov',
    emr: 'Elektronické zdravotné záznamy (EMR)',
    cpr: 'Certifikácia CPR',
    first_aid: 'Prvá pomoc',
    vital_signs: 'Monitorovanie životných funkcií',
    medication_admin: 'Podávanie liekov',
    medical_coding: 'Lekárske kódovanie',
    healthcare_compliance: 'Compliance v zdravotníctve',
    hipaa: 'Znalosť HIPAA',

    // Logistika
    supply_chain: 'Riadenie dodávateľského reťazca',
    warehouse_management: 'Správa skladu',
    inventory_control: 'Kontrola zásob',
    forklift: 'Obsluha vysokozdvižného vozíka',
    shipping_receiving: 'Expedícia & Príjem',
    logistics_coordination: 'Koordinácia logistiky',
    quality_control: 'Kontrola kvality',
    route_planning: 'Plánovanie trás',
    procurement: 'Nákup',
    wms_software: 'WMS software',

    // Nové zručnosti z migrácie 56 (zoradené abecedne)
    '3d_visualization': '3D vizualizácia',
    abap: 'ABAP',
    academic_supervision: 'Akademický dohľad',
    access_control: 'Riadenie prístupu',
    access_control_systems: 'Systémy riadenia prístupu',
    accounting_software: 'Účtovný softvér',
    acoustics: 'Akustika',
    active_listening: 'Aktívne počúvanie',
    activity_planning: 'Plánovanie aktivít',
    actuarial_software: 'Aktuársky softvér',
    adaptive_teaching: 'Adaptívne učenie',
    adas_recalibration: 'ADAS rekalibrá cia',
    adhesive_application: 'Aplikácia lepidiel',
    administrative_law: 'Správne právo',
    advanced_nursing: 'Pokročilé ošetrovateľstvo',
    adverse_event_reporting: 'Hlásenie nežiaducich udalostí',
    advertising_sales: 'Predaj reklamy',
    advisory_services: 'Poradenské služby',
    agricultural_law: 'Poľnohospodárske právo',
    agricultural_machinery: 'Poľnohospodárske stroje',
    agricultural_software: 'Poľnohospodársky softvér',
    aircraft_systems: 'Lietadlové systémy',
    alarm_systems: 'Poplašné systémy',
    alignment_equipment: 'Zariadenie na nastavenie geometrie',
    alterations: 'Úpravy',
    analytical_chemistry: 'Analytická chémia',
    analytics: 'Analytika',
    anatomy_knowledge: 'Znalosť anatómie',
    android_studio: 'Android Studio',
    anesthesia: 'Anestézia',
    animal_handling: 'Manipulácia so zvieratami',
    animal_husbandry: 'Chov zvierat',
    animal_nutrition: 'Výživa zvierat',
    animal_surgery: 'Veterinárna chirurgia',
    animation: 'Animácia',
    api_documentation: 'API dokumentácia',
    applicant_tracking_systems: 'Systémy sledovania uchádzačov (ATS)',
    arc_welding: 'Oblúkové zváranie',
    architectural_design: 'Architektonický dizajn',
    archival_procedures: 'Archivačné postupy',
    art_history: 'Dejiny umenia',
    aspen_plus: 'Aspen Plus',
    assembly_procedures: 'Montážne postupy',
    assessment: 'Hodnotenie',
    audience_analysis: 'Analýza publika',
    audio_editing: 'Úprava zvuku',
    audio_engineering: 'Zvukové inžinierstvo',
    audit_procedures: 'Audítorské postupy',
    autocad: 'AutoCAD',
    autocad_mep: 'AutoCAD MEP',
    automotive_diagnostics: 'Automobilová diagnostika',
    automotive_electronics: 'Automobilová elektronika',
    automotive_painting: 'Automobilové lakírovanie',
    automotive_software: 'Automobilový softvér',
    award_presentations: 'Udeľovanie ocenení',
    bakery_equipment: 'Pekárenské zariadenia',
    bankruptcy_law: 'Konkurzné právo',
    bar_operations: 'Prevádzka baru',
    batch_processing: 'Dávkové spracovanie',
    battery_management: 'Správa batérií',
    behavioral_assessment: 'Behaviorálne hodnotenie',
    benefit_administration: 'Správa zamestnaneckých výhod',
    beverage_service: 'Podávanie nápojov',
    bidding: 'Verejné obstarávanie',
    billing: 'Fakturácia',
    bim: 'BIM',
    biochemistry: 'Biochémia',
    blueprint_reading: 'Čítanie výkresov',
    boat_maintenance: 'Údržba lodí',
    body_repair: 'Oprava karosérie',
    bookbinding: 'Kníhviazačstvo',
    brake_systems: 'Brzdové systémy',
    brand_development: 'Rozvoj značky',
    brewing: 'Varenie piva',
    broadcast_engineering: 'Vysielacie inžinierstvo',
    building_codes: 'Stavebné predpisy',
    building_maintenance: 'Údržba budov',
    building_regulations: 'Stavebné nariadenia',
    business_analysis: 'Obchodná analýza',
    business_law: 'Obchodné právo',
    cad_cam_dental: 'CAD/CAM dentálne',
    cad_software: 'CAD softvér',
    calibration: 'Kalibrácia',
    cam_software: 'CAM softvér',
    camera_operation: 'Obsluha kamery',
    campaign_management: 'Riadenie kampaní',
    candidate_evaluation: 'Hodnotenie kandidátov',
    candidate_screening: 'Skríning kandidátov',
    candidate_sourcing: 'Vyhľadávanie kandidátov',
    cannabis_cultivation: 'Pestovanie konope',
    caregiver_support: 'Podpora opatrovateľov',
    carpentry: 'Stolárstvo',
    case_management: 'Správa prípadov',
    cash_handling: 'Manipulácia s hotovosťou',
    catia: 'CATIA',
    cctv_systems: 'CCTV systémy',
    ceramic_techniques: 'Keramické techniky',
    ceremony_planning: 'Plánovanie ceremónií',
    change_management: 'Riadenie zmien',
    chemical_engineering: 'Chemické inžinierstvo',
    chemical_handling: 'Manipulácia s chemikáliami',
    chemical_processes: 'Chemické procesy',
    chemistry: 'Chémia',
    child_development: 'Vývoj dieťaťa',
    child_nutrition: 'Výživa detí',
    child_safety: 'Bezpečnosť detí',
    civil_3d: 'Civil 3D',
    civil_engineering: 'Stavebné inžinierstvo',
    civil_law: 'Občianske právo',
    claim_processing: 'Spracovanie poistných udalostí',
    class_management: 'Riadenie tried',
    classroom_management: 'Riadenie triedy',
    cleaning_procedures: 'Čistiace postupy',
    client_counseling: 'Poradenstvo pre klientov',
    client_interaction: 'Interakcia s klientmi',
    climate_control: 'Klimatizácia',
    clinical_documentation: 'Klinická dokumentácia',
    clinical_protocols: 'Klinické protokoly',
    clinical_research: 'Klinický výskum',
    clinical_skills: 'Klinické zručnosti',
    cloud_services: 'Cloudové služby',
    cnc_operation: 'Obsluha CNC',
    cnc_programming: 'CNC programovanie',
    cnc_setup: 'Nastavenie CNC',
    coaching: 'Koučovanie',
    coating_application: 'Aplikácia povlakov',
    cocktail_preparation: 'Príprava koktailov',
    coding_standards: 'Kódovacie štandardy',
    cognitive_assessment: 'Kognitívne hodnotenie',
    color_matching: 'Zladenie farieb',
    combustion_systems: 'Spaľovacie systémy',
    commercial_law: 'Obchodné právo',
    community_engagement: 'Zapojenie komunity',
    community_outreach: 'Komunitný rozvoj',
    compensation_analysis: 'Analýza odmien',
    competitive_analysis: 'Konkurenčná analýza',
    compiler_design: 'Návrh kompilátorov',
    compliance_auditing: 'Audit súladu',
    compliance_documentation: 'Dokumentácia súladu',
    compliance_management: 'Riadenie súladu',
    compliance_monitoring: 'Monitorovanie súladu',
    compliance_reporting: 'Reportovanie súladu',
    compliance_training: 'Školenie o súlade',
    component_testing: 'Testovanie komponentov',
    composting: 'Kompostovanie',
    computer_hardware: 'Počítačový hardvér',
    concrete_work: 'Betónárske práce',
    conflict_management: 'Riadenie konfliktov',
    constitutional_law: 'Ústavné právo',
    construction_management: 'Riadenie výstavby',
    construction_safety: 'Bezpečnosť na stavbe',
    content_creation: 'Tvorba obsahu',
    content_development: 'Vývoj obsahu',
    content_moderation: 'Moderovanie obsahu',
    continuous_improvement: 'Neustále zlepšovanie',
    contract_drafting: 'Návrh zmlúv',
    contract_law: 'Zmluvné právo',
    contract_negotiation: 'Vyjednávanie zmlúv',
    control_systems: 'Riadiace systémy',
    corporate_law: 'Korporátne právo',
    corrective_actions: 'Nápravné opatrenia',
    cost_analysis: 'Nákladová analýza',
    cost_control: 'Kontrola nákladov',
    cost_estimation: 'Odhad nákladov',
    counseling: 'Poradenstvo',
    course_development: 'Vývoj kurzov',
    court_procedures: 'Súdne konania',
    crane_operation: 'Obsluha žeriavu',
    creative_direction: 'Kreatívna réžia',
    credit_analysis: 'Úverová analýza',
    criminal_law: 'Trestné právo',
    crisis_intervention: 'Krízová intervencia',
    crisis_management: 'Krízové riadenie',
    critical_care: 'Intenzívna starostlivosť',
    crop_management: 'Správa plodín',
    crop_protection: 'Ochrana plodín',
    culinary_arts: 'Kulinárske umenie',
    cultural_sensitivity: 'Kultúrna citlivosť',
    curriculum_design: 'Návrh učebných osnov',
    curriculum_development: 'Vývoj učebných osnov',
    custom_fabrication: 'Kusová výroba',
    customer_education: 'Vzdelávanie zákazníkov',
    customer_engagement: 'Zapojenie zákazníkov',
    customer_retention: 'Udržanie zákazníkov',
    customer_service: 'Zákaznícky servis',
    customs_regulations: 'Colné predpisy',
    cutting_techniques: 'Techniky rezania',
    data_collection: 'Zber dát',
    data_interpretation: 'Interpretácia dát',
    data_management: 'Správa dát',
    database_design: 'Návrh databáz',
    database_management: 'Správa databáz',
    deal_negotiation: 'Vyjednávanie obchodov',
    decision_support: 'Podpora rozhodovania',
    decorating: 'Dekorovanie',
    demolition: 'Demolácia',
    dental_equipment: 'Zubné zariadenia',
    dental_hygiene: 'Dentálna hygiena',
    dental_procedures: 'Zubné postupy',
    design_software: 'Dizajnový softvér',
    design_thinking: 'Dizajnové myslenie',
    desktop_support: 'Desktopová podpora',
    diagnostic_equipment: 'Diagnostické zariadenia',
    diagnostic_imaging: 'Diagnostické zobrazovanie',
    diagnostic_testing: 'Diagnostické testovanie',
    diesel_engines: 'Dieselové motory',
    diet_planning: 'Plánovanie stravy',
    differentiated_instruction: 'Diferencované vyučovanie',
    digital_fabrication: 'Digitálna výroba',
    digital_literacy: 'Digitálna gramotnosť',
    digital_marketing: 'Digitálny marketing',
    disability_awareness: 'Povedomie o zdravotnom postihnutí',
    disability_support: 'Podpora osôb so zdravotným postihnutím',
    disaster_response: 'Reakcia na katastrofy',
    disinfection: 'Dezinfekcia',
    dispensing: 'Výdaj liekov',
    dispute_resolution: 'Riešenie sporov',
    distribution_management: 'Riadenie distribúcie',
    document_control: 'Kontrola dokumentov',
    document_review: 'Kontrola dokumentov',
    dosage_calculation: 'Výpočet dávkovania',
    drainage_systems: 'Odvodnóvacie systémy',
    drawing_interpretation: 'Interpretácia výkresov',
    drilling: 'Vŕtanie',
    drone_operation: 'Obsluha dronov',
    drug_interactions: 'Liekové interakcie',
    drywall: 'Sadrokartón',
    due_diligence: 'Due diligence',
    e_learning: 'E-learning',
    ecg_interpretation: 'Interpretácia EKG',
    educational_assessment: 'Vzdelávacie hodnotenie',
    educational_software: 'Vzdelávací softvér',
    educational_technology: 'Vzdelávacie technológie',
    electrical_cad: 'Elektrické CAD',
    electrical_codes: 'Elektrické predpisy',
    electrical_installation: 'Elektroinštalácia',
    electrical_maintenance: 'Údržba elektrických zariadení',
    electrical_systems: 'Elektrické systémy',
    electrical_testing: 'Testovanie elektrických zariadení',
    electrical_troubleshooting: 'Riešenie problémov s elektrinou',
    electronic_assembly: 'Elektronická montáž',
    electronic_testing: 'Testovanie elektroniky',
    electronics_repair: 'Oprava elektroniky',
    embedded_systems: 'Vstavané systémy',
    emergency_care: 'Urgentná starostlivosť',
    emergency_preparedness: 'Pripravenosť na núdzové situácie',
    emergency_procedures: 'Núdzové postupy',
    emergency_response: 'Núdzová reakcia',
    emissions_testing: 'Testovanie emisií',
    employee_engagement: 'Angažovanosť zamestnancov',
    employee_relations: 'Vzťahy so zamestnancami',
    employment_law: 'Pracovné právo',
    encryption: 'Šifrovanie',
    end_of_life_care: 'Paliatívna starostlivosť',
    energy_efficiency: 'Energetická efektívnosť',
    energy_management: 'Energetický manažment',
    engine_diagnostics: 'Diagnostika motora',
    engine_repair: 'Oprava motora',
    environmental_compliance: 'Environmentálny súlad',
    environmental_impact: 'Environmentálny vplyv',
    environmental_law: 'Environmentálne právo',
    environmental_monitoring: 'Environmentálne monitorovanie',
    environmental_science: 'Environmentálna veda',
    equipment_calibration: 'Kalibrácia zariadení',
    equipment_inspection: 'Inšpekcia zariadení',
    equipment_maintenance: 'Údržba zariadení',
    equipment_operation: 'Obsluha zariadení',
    equipment_repair: 'Oprava zariadení',
    equipment_setup: 'Nastavenie zariadení',
    ergonomics: 'Ergonómia',
    escalation_management: 'Riadenie eskalácie',
    estate_planning: 'Plánovanie dedičstva',
    ethical_standards: 'Etické štandardy',
    event_coordination: 'Koordinácia udalostí',
    event_planning: 'Plánovanie podujatí',
    evidence_collection: 'Zber dôkazov',
    evidence_handling: 'Manipulácia s dôkazmi',
    excavation: 'Výkopové práce',
    exhibit_design: 'Návrh výstav',
    experimental_design: 'Návrh experimentov',
    facility_management: 'Správa zariadení',
    family_law: 'Rodinné právo',
    fashion_design: 'Módny dizajn',
    fastening_systems: 'Upevňovacie systémy',
    feasibility_studies: 'Štúdie uskutočniteľnosti',
    feed_formulation: 'Formulácia krmív',
    feedback_analysis: 'Analýza spätnej väzby',
    feedback_collection: 'Zber spätnej väzby',
    fermentation: 'Fermentácia',
    fertilization: 'Hnojenie',
    field_service: 'Terénny servis',
    filing_systems: 'Archivačné systémy',
    film_production: 'Filmová produkcia',
    filtration_systems: 'Filtračné systémy',
    financial_management: 'Finančné riadenie',
    financial_modeling: 'Finančné modelovanie',
    financial_planning: 'Finančné plánovanie',
    fire_safety: 'Požiarna bezpečnosť',
    fire_systems: 'Požiarne systémy',
    firewall_management: 'Správa firewalu',
    firmware_development: 'Vývoj firmvéru',
    fitting: 'Montáž',
    fixture_installation: 'Inštalácia svietidiel',
    fleet_management: 'Správa vozového parku',
    flooring: 'Podlahy',
    food_handling: 'Manipulácia s potravinami',
    food_preparation: 'Príprava jedál',
    food_safety: 'Bezpečnosť potravín',
    food_service: 'Stravovacie služby',
    forecasting: 'Prognózovanie',
    forensic_analysis: 'Forenzná analýza',
    formulation: 'Formulácia',
    foundation_work: 'Základové práce',
    framing: 'Konštrukcia kostry',
    freight_handling: 'Manipulácia s nákladom',
    front_desk: 'Recepcia',
    front_end_alignment: 'Nastavenie prednej geometrie',
    fuel_systems: 'Palivové systémy',
    fundraising: 'Fundraising',
    furniture_assembly: 'Montáž nábytku',
    furniture_design: 'Návrh nábytku',
    g_code: 'G-kód',
    garment_construction: 'Konštrukcia odevov',
    gdpr: 'GDPR',
    gem_identification: 'Identifikácia drahokamov',
    geriatric_care: 'Geriatrická starostlivosť',
    glass_installation: 'Inštalácia skla',
    glazing: 'Zasklievanie',
    gmp: 'GMP',
    grant_writing: 'Písanie grantov',
    graphic_software: 'Grafický softvér',
    greenhouse_management: 'Správa skleníkov',
    grief_counseling: 'Poradenstvo v smútku',
    grinding: 'Brúsenie',
    grooming: 'Grooming',
    groundwater_monitoring: 'Monitorovanie podzemných vôd',
    group_facilitation: 'Facilitácia skupín',
    group_therapy: 'Skupinová terapia',
    guest_relations: 'Vzťahy s hosťami',
    guest_services: 'Služby pre hostí',
    hand_tools: 'Ručné náradie',
    handling_techniques: 'Techniky manipulácie',
    hardware_installation: 'Inštalácia hardvéru',
    hardware_troubleshooting: 'Riešenie problémov s hardvérom',
    harvest_management: 'Riadenie úrody',
    hazardous_materials: 'Nebezpečné látky',
    hazmat: 'HAZMAT',
    health_education: 'Zdravotná výchova',
    health_informatics: 'Zdravotnícka informatika',
    health_promotion: 'Podpora zdravia',
    health_screening: 'Zdravotný skríning',
    hearing_tests: 'Sluchové testy',
    heat_treatment: 'Tepelné spracovanie',
    heating_systems: 'Vykurovacie systémy',
    heavy_equipment: 'Ťažká technika',
    help_desk: 'Help desk',
    herd_management: 'Riadenie stáda',
    historical_research: 'Historický výskum',
    horticulture: 'Záhradníctvo',
    hospitality_management: 'Riadenie pohostinstva',
    housekeeping: 'Upratovanie',
    hr_analytics: 'HR analytika',
    hr_policies: 'HR politiky',
    hr_software: 'HR softvér',
    hvac: 'HVAC',
    hvac_design: 'Návrh HVAC',
    hvac_installation: 'Inštalácia HVAC',
    hvac_systems: 'HVAC systémy',
    hydraulic_systems: 'Hydraulické systémy',
    hygiene_protocols: 'Hygienické protokoly',
    ict_integration: 'Integrácia IKT',
    illustration: 'Ilustrácia',
    image_processing: 'Spracovanie obrazu',
    imaging_equipment: 'Zobrazovacie zariadenia',
    immigration_law: 'Imigračné právo',
    immunization: 'Imunizácia',
    impact_assessment: 'Posúdenie vplyvu',
    incident_investigation: 'Vyšetrovanie incidentov',
    incident_management: 'Riadenie incidentov',
    incident_reporting: 'Hlásenie incidentov',
    inclusive_education: 'Inkluzívne vzdelávanie',
    individual_education_plans: 'Individuálne vzdelávacie plány',
    industrial_automation: 'Priemyselná automatizácia',
    industrial_design: 'Priemyselný dizajn',
    industrial_equipment: 'Priemyselné zariadenia',
    industrial_maintenance: 'Priemyselná údržba',
    infection_control: 'Kontrola infekcií',
    infusion_therapy: 'Infúzna terapia',
    injection_molding: 'Vstrekovanie plastov',
    inspection_procedures: 'Inšpekčné postupy',
    installation_procedures: 'Inštalačné postupy',
    instructional_design: 'Návrh vzdelávania',
    instrument_calibration: 'Kalibrácia prístrojov',
    instrumentation: 'Prístrojová technika',
    insulation: 'Izolácia',
    insurance_law: 'Poisťovacie právo',
    integration_testing: 'Integračné testovanie',
    intellectual_property: 'Duševné vlastníctvo',
    interactive_learning: 'Interaktívne učenie',
    interior_design: 'Interiérový dizajn',
    interpreting: 'Tlmočenie',
    interview_techniques: 'Techniky interview',
    interviewing: 'Vedenie interview',
    inventory_management: 'Správa zásob',
    investment_analysis: 'Investičná analýza',
    irrigation: 'Zavlažovanie',
    irrigation_systems: 'Zavlažovacie systémy',
    iso_9001: 'ISO 9001',
    jewelry_making: 'Výroba šperkov',
    jewelry_repair: 'Oprava šperkov',
    job_analysis: 'Analýza pracovných pozícií',
    job_costing: 'Kalkulácia zákaziek',
    labor_law: 'Pracovné právo',
    labor_relations: 'Pracovné vzťahy',
    laboratory_equipment: 'Laboratórne zariadenia',
    laboratory_procedures: 'Laboratórne postupy',
    laboratory_techniques: 'Laboratórne techniky',
    landscape_design: 'Krajinársky dizajn',
    landscape_maintenance: 'Údržba zelene',
    language_instruction: 'Jazyková výučba',
    lathe_operation: 'Obsluha sústruhu',
    laundry_operations: 'Práčovňa',
    layout_design: 'Návrh rozloženia',
    lean_principles: 'Lean princípy',
    learning_assessment: 'Hodnotenie učenia',
    learning_disabilities: 'Poruchy učenia',
    legal_compliance: 'Právny súlad',
    legal_documentation: 'Právna dokumentácia',
    legal_research: 'Právny výskum',
    legal_writing: 'Právne písanie',
    lesson_planning: 'Plánovanie vyučovacích hodín',
    library_management: 'Správa knižníc',
    library_systems: 'Knižničné systémy',
    licensing: 'Licencovanie',
    lifting_equipment: 'Zdvíhacie zariadenia',
    lighting_design: 'Svetelný dizajn',
    lighting_systems: 'Osvetľovacie systémy',
    literature_review: 'Literárna rešerš',
    litigation: 'Súdne spory',
    livestock_management: 'Riadenie hospodárskych zvierat',
    load_calculation: 'Výpočet zaťaženia',
    loan_processing: 'Spracovanie úverov',
    lockout_tagout: 'Lockout/Tagout',
    logistics_planning: 'Logistické plánovanie',
    loss_prevention: 'Prevencia strát',
    low_voltage_systems: 'Nízkonapäťové systémy',
    lubrication: 'Mazanie',
    machine_learning_engineering: 'Strojové učenie - inžinierstvo',
    machine_operation: 'Obsluha strojov',
    machine_setup: 'Nastavenie strojov',
    machining_processes: 'Obrábacie procesy',
    maintenance_planning: 'Plánovanie údržby',
    maintenance_procedures: 'Postupy údržby',
    makeup_application: 'Aplikácia make-upu',
    manufacturing_processes: 'Výrobné procesy',
    maritime_law: 'Námorné právo',
    market_analysis: 'Trhová analýza',
    market_research: 'Prieskum trhu',
    masonry: 'Murárstvo',
    massage_therapy: 'Masážna terapia',
    materials_handling: 'Manipulácia s materiálmi',
    materials_science: 'Materiálové inžinierstvo',
    materials_selection: 'Výber materiálov',
    measurement_techniques: 'Meracie techniky',
    mechanical_assembly: 'Mechanická montáž',
    mechanical_design: 'Mechanický dizajn',
    mechanical_systems: 'Mechanické systémy',
    media_relations: 'Vzťahy s médiami',
    medical_billing: 'Zdravotná fakturácia',
    medical_documentation: 'Lekárska dokumentácia',
    medical_equipment: 'Lekárske zariadenia',
    medical_imaging: 'Lekárske zobrazovanie',
    medical_records: 'Zdravotné záznamy',
    medical_software: 'Zdravotnícky softvér',
    medication_dispensing: 'Výdaj liekov',
    medication_management: 'Správa liekov',
    membership_management: 'Správa členstva',
    mental_health: 'Duševné zdravie',
    menu_development: 'Vývoj menu',
    menu_planning: 'Plánovanie menu',
    merchandising: 'Merchandising',
    metal_fabrication: 'Kovospracovanie',
    metalworking: 'Kovoobrábanie',
    microbiology: 'Mikrobiológia',
    mig_welding: 'MIG zváranie',
    milling: 'Frézovanie',
    mixing: 'Miešanie',
    mobile_development: 'Mobilný vývoj',
    mobile_repair: 'Oprava mobilov',
    mortuary_services: 'Pohrebné služby',
    motor_control: 'Riadenie motorov',
    motor_repair: 'Oprava motorov',
    multimedia_production: 'Multimediálna produkcia',
    museum_education: 'Múzejná pedagogika',
    music_education: 'Hudobná výchova',
    music_performance: 'Hudobné vystúpenie',
    music_production: 'Hudobná produkcia',
    music_theory: 'Hudobná teória',
    narrative_writing: 'Naratívne písanie',
    network_administration: 'Správa sietí',
    network_configuration: 'Konfigurácia sietí',
    network_design: 'Návrh sietí',
    network_installation: 'Inštalácia sietí',
    network_maintenance: 'Údržba sietí',
    network_monitoring: 'Monitorovanie sietí',
    network_security: 'Sieťová bezpečnosť',
    network_troubleshooting: 'Riešenie sieťových problémov',
    neurological_assessment: 'Neurologické vyšetrenie',
    news_writing: 'Novinárske písanie',
    nonprofit_management: 'Riadenie neziskových organizácií',
    notary_services: 'Notárske služby',
    nursery_management: 'Riadenie škôlky',
    nursing_assessment: 'Ošetrovateľské vyšetrenie',
    nutrition_counseling: 'Výživové poradenstvo',
    objective_c: 'Objective-C',
    occupational_health: 'Pracovné zdravie',
    occupational_therapy: 'Pracovná terapia',
    oil_analysis: 'Analýza olejov',
    onboarding: 'Onboarding',
    operating_systems: 'Operačné systémy',
    operational_efficiency: 'Prevádzkova efektívnosť',
    operations_management: 'Riadenie prevádzky',
    optical_systems: 'Optické systémy',
    order_fulfillment: 'Vybavovanie objednávok',
    order_processing: 'Spracovanie objednávok',
    organic_chemistry: 'Organická chémia',
    organic_farming: 'Ekologické poľnohospodárstvo',
    organizational_development: 'Organizačný rozvoj',
    orthodontics: 'Ortodoncia',
    orthopedics: 'Ortopédia',
    packaging: 'Balenie',
    packaging_design: 'Dizajn obalov',
    pain_management: 'Riadenie bolesti',
    painting: 'Maľovanie',
    palliative_care: 'Paliatívna starostlivosť',
    paramedic_care: 'Zdravotnícka záchranná služba',
    parent_communication: 'Komunikácia s rodičmi',
    parking_management: 'Správa parkovania',
    parts_management: 'Správa náhradných dielov',
    pastry_arts: 'Cukrárstvo',
    patent_law: 'Patentové právo',
    pathology: 'Patológia',
    patient_assessment: 'Vyšetrenie pacienta',
    patient_communication: 'Komunikácia s pacientmi',
    patient_education: 'Vzdelávanie pacientov',
    patient_monitoring: 'Monitorovanie pacientov',
    patient_scheduling: 'Plánovanie pacientov',
    pattern_making: 'Strihovanie',
    payroll_administration: 'Správa miezd',
    pcb_design: 'Návrh PCB',
    pediatric_care: 'Pediatrická starostlivosť',
    performance_evaluation: 'Hodnotenie výkonu',
    performance_management: 'Riadenie výkonu',
    performance_testing: 'Výkonnostné testovanie',
    permit_processing: 'Spracovanie povolení',
    personal_training: 'Osobný tréning',
    pest_control: 'Ničenie škodcov',
    pest_management: 'Riadenie škodcov',
    pharmaceutical_calculations: 'Farmaceutické výpočty',
    pharmacology: 'Farmakológia',
    pharmacy_operations: 'Prevádzka lekárne',
    phlebotomy: 'Flebotómia',
    photography: 'Fotografovanie',
    physical_assessment: 'Fyzické vyšetrenie',
    physical_therapy: 'Fyzioterapia',
    physics: 'Fyzika',
    piping_systems: 'Potrubie',
    plan_review: 'Kontrola projektov',
    plant_operations: 'Prevádzka závodu',
    plasma_cutting: 'Plazmové rezanie',
    plastering: 'Omietanie',
    plc_programming: 'PLC programovanie',
    plsql: 'PL/SQL',
    plumbing: 'Inštalatérstvo',
    plumbing_codes: 'Inštalatérske predpisy',
    plumbing_systems: 'Inštalatérske systémy',
    pneumatic_systems: 'Pneumatické systémy',
    point_of_sale: 'Pokladňa',
    policy_analysis: 'Analýza politík',
    policy_development: 'Vývoj politík',
    pollination_management: 'Riadenie opeľovania',
    pollution_control: 'Kontrola znečistenia',
    polymer_science: 'Polyméry',
    portfolio_management: 'Správa portfólia',
    pos_systems: 'POS systémy',
    post_production: 'Postprodukcia',
    power_distribution: 'Distribúcia energie',
    power_systems: 'Energetické systémy',
    power_tools: 'Elektrické náradie',
    precision_machining: 'Presné obrábanie',
    precision_measurement: 'Presné meranie',
    predictive_maintenance: 'Prediktívna údržba',
    preventive_maintenance: 'Preventívna údržba',
    print_production: 'Tlačová produkcia',
    process_control: 'Riadenie procesov',
    process_design: 'Návrh procesov',
    process_documentation: 'Dokumentácia procesov',
    process_engineering: 'Procesné inžinierstvo',
    process_improvement: 'Zlepšovanie procesov',
    process_optimization: 'Optimalizácia procesov',
    process_validation: 'Validácia procesov',
    product_design: 'Návrh produktu',
    product_development: 'Vývoj produktu',
    product_knowledge: 'Znalosť produktov',
    product_testing: 'Testovanie produktov',
    production_planning: 'Plánovanie výroby',
    production_scheduling: 'Rozvrhovanie výroby',
    program_evaluation: 'Hodnotenie programov',
    program_management: 'Riadenie programov',
    project_coordination: 'Koordinácia projektov',
    project_documentation: 'Projektová dokumentácia',
    project_planning: 'Plánovanie projektov',
    project_scheduling: 'Rozvrhovanie projektov',
    promotion_planning: 'Plánovanie propagácie',
    proofreading: 'Korektúra',
    property_law: 'Majetkové právo',
    property_maintenance: 'Údržba nehnuteľností',
    property_management: 'Správa nehnuteľností',
    proposal_writing: 'Písanie návrhov',
    prosthetics: 'Protetika',
    prototyping: 'Prototypovanie',
    psychiatric_care: 'Psychiatrická starostlivosť',
    psychological_assessment: 'Psychologické vyšetrenie',
    public_health: 'Verejné zdravie',
    public_relations: 'Vzťahy s verejnosťou',
    purchasing: 'Nákup',
    quality_assurance: 'Zabezpečenie kvality',
    quality_documentation: 'Dokumentácia kvality',
    quality_inspection: 'Kontrola kvality',
    quality_standards: 'Normy kvality',
    quality_systems: 'Systémy kvality',
    quality_testing: 'Testovanie kvality',
    quantity_surveying: 'Rozpočtárstvo',
    radiography: 'Rádiografia',
    radiology: 'Rádiológia',
    real_estate_law: 'Právo nehnuteľností',
    receiving: 'Príjem tovaru',
    recipe_development: 'Vývoj receptúr',
    record_keeping: 'Vedenie záznamov',
    recruitment: 'Nábor',
    recycling_programs: 'Recyklačné programy',
    refrigeration: 'Chladenie',
    refrigeration_systems: 'Chladiace systémy',
    regulatory_affairs: 'Regulačné záležitosti',
    regulatory_compliance: 'Regulačný súlad',
    rehabilitation: 'Rehabilitácia',
    reliability_engineering: 'Inžinierstvo spoľahlivosti',
    remote_support: 'Vzdialená podpora',
    renewable_energy: 'Obnoviteľné zdroje energie',
    repair_procedures: 'Opravné postupy',
    repair_techniques: 'Opravné techniky',
    report_writing: 'Písanie správ',
    reservation_systems: 'Rezervačné systémy',
    residential_care: 'Rezidenčná starostlivosť',
    resource_allocation: 'Alokácia zdrojov',
    resource_management: 'Správa zdrojov',
    resource_planning: 'Plánovanie zdrojov',
    respiratory_care: 'Respiračná starostlivosť',
    respiratory_therapy: 'Respiračná terapia',
    restaurant_management: 'Riadenie reštaurácie',
    restoration: 'Reštaurovanie',
    retail_management: 'Riadenie maloobchodu',
    retail_operations: 'Maloobchodné operácie',
    revenue_management: 'Riadenie príjmov',
    revit: 'Revit',
    rfid_systems: 'RFID systémy',
    risk_analysis: 'Analýza rizík',
    risk_assessment: 'Posúdenie rizík',
    risk_management: 'Riadenie rizík',
    robotics: 'Robotika',
    roofing: 'Pokrývačstvo',
    room_service: 'Izbová služba',
    root_cause_analysis: 'Analýza hlavných príčin',
    safety_audits: 'Bezpečnostné audity',
    safety_equipment: 'Bezpečnostné vybavenie',
    safety_inspections: 'Bezpečnostné inšpekcie',
    safety_procedures: 'Bezpečnostné postupy',
    safety_protocols: 'Bezpečnostné protokoly',
    safety_regulations: 'Bezpečnostné predpisy',
    safety_systems: 'Bezpečnostné systémy',
    safety_training: 'Bezpečnostné školenie',
    salon_management: 'Riadenie salónu',
    sample_preparation: 'Príprava vzoriek',
    sanitation: 'Sanitácia',
    sanitation_procedures: 'Sanitačné postupy',
    sawing: 'Pílenie',
    scada: 'SCADA',
    scaffolding: 'Lešenie',
    scanning_equipment: 'Skenovacie zariadenia',
    scheduling: 'Plánovanie',
    schematic_design: 'Schématický návrh',
    schematic_reading: 'Čítanie schém',
    scope_management: 'Riadenie rozsahu',
    scripting: 'Skriptovanie',
    sculptural_techniques: 'Sochárske techniky',
    security_assessment: 'Bezpečnostné posúdenie',
    security_monitoring: 'Bezpečnostné monitorovanie',
    security_operations: 'Bezpečnostné operácie',
    security_protocols: 'Bezpečnostné protokoly',
    security_systems: 'Bezpečnostné systémy',
    seed_selection: 'Výber osiva',
    sensor_technology: 'Senzorová technológia',
    server_administration: 'Správa serverov',
    server_maintenance: 'Údržba serverov',
    service_coordination: 'Koordinácia služieb',
    service_delivery: 'Poskytovanie služieb',
    service_documentation: 'Servisná dokumentácia',
    service_management: 'Správa služieb',
    service_writing: 'Písanie servisnej dokumentácie',
    sewing: 'Šitie',
    sheet_metal: 'Plechárstvo',
    sheet_metal_fabrication: 'Spracovanie plechu',
    shelving: 'Regálové systémy',
    shipping: 'Expedícia',
    signal_processing: 'Spracovanie signálov',
    site_management: 'Riadenie staveniska',
    site_preparation: 'Príprava staveniska',
    site_supervision: 'Stavebný dohľad',
    sketchup: 'SketchUp',
    skincare: 'Starostlivosť o pleť',
    social_media_management: 'Správa sociálnych médií',
    social_services: 'Sociálne služby',
    social_work: 'Sociálna práca',
    software_architecture: 'Softvérová architektúra',
    software_deployment: 'Nasadenie softvéru',
    software_documentation: 'Softvérová dokumentácia',
    software_integration: 'Integrácia softvéru',
    software_testing: 'Testovanie softvéru',
    soil_analysis: 'Analýza pôdy',
    soil_management: 'Správa pôdy',
    solar_installation: 'Inštalácia solárnych panelov',
    soldering: 'Spájkovanie',
    solidworks: 'SolidWorks',
    sound_design: 'Zvukový dizajn',
    sound_engineering: 'Zvukové inžinierstvo',
    spa_services: 'Spa služby',
    space_planning: 'Priestorové plánovanie',
    special_education: 'Špeciálna pedagogika',
    spectroscopy: 'Spektroskopia',
    speech_therapy: 'Logopédia',
    sports_coaching: 'Športový koučing',
    sports_medicine: 'Športová medicína',
    spray_painting: 'Striekanie farbou',
    stakeholder_engagement: 'Zapojenie zainteresovaných strán',
    stakeholder_management: 'Riadenie zainteresovaných strán',
    statistical_analysis: 'Štatistická analýza',
    steam_systems: 'Parné systémy',
    steel_fabrication: 'Spracovanie ocele',
    sterilization: 'Sterilizácia',
    stock_management: 'Správa skladov',
    storage_management: 'Správa úložísk',
    storyboarding: 'Storyboarding',
    strategic_planning: 'Strategické plánovanie',
    stress_testing: 'Záťažové testovanie',
    structural_analysis: 'Štrukturálna analýza',
    structural_design: 'Konštrukčný návrh',
    student_assessment: 'Hodnotenie študentov',
    student_counseling: 'Poradenstvo pre študentov',
    student_engagement: 'Angažovanosť študentov',
    student_support: 'Podpora študentov',
    substance_abuse: 'Závislosť od látok',
    succession_planning: 'Plánovanie nástupníctva',
    supplier_management: 'Správa dodávateľov',
    supply_planning: 'Plánovanie dodávok',
    surface_preparation: 'Príprava povrchu',
    surgical_assistance: 'Chirurgická asistencia',
    surgical_instruments: 'Chirurgické nástroje',
    surgical_procedures: 'Chirurgické postupy',
    surveillance_systems: 'Sledovacie systémy',
    survey_design: 'Návrh prieskumov',
    surveying: 'Geodézia',
    suspension_systems: 'Systémy zavesenia',
    sustainability_practices: 'Udržateľné postupy',
    system_administration: 'Správa systémov',
    system_configuration: 'Konfigurácia systémov',
    system_design: 'Návrh systémov',
    system_documentation: 'Systémová dokumentácia',
    system_integration: 'Integrácia systémov',
    system_maintenance: 'Údržba systémov',
    system_monitoring: 'Monitorovanie systémov',
    system_optimization: 'Optimalizácia systémov',
    system_testing: 'Testovanie systémov',
    systems_analysis: 'Systémová analýza',
    talent_acquisition: 'Získavanie talentov',
    talent_development: 'Rozvoj talentov',
    tax_law: 'Daňové právo',
    tax_planning: 'Daňové plánovanie',
    team_building: 'Budovanie tímu',
    team_coordination: 'Koordinácia tímu',
    team_leadership: 'Vedenie tímu',
    technical_documentation: 'Technická dokumentácia',
    technical_drawing: 'Technické kreslenie',
    technical_support: 'Technická podpora',
    technical_training: 'Technické školenie',
    technical_writing: 'Technické písanie',
    technology_integration: 'Integrácia technológií',
    telecommunications: 'Telekomunikácie',
    telemedicine: 'Telemedicína',
    tenant_relations: 'Vzťahy s nájomníkmi',
    testing_procedures: 'Testovacie postupy',
    textile_design: 'Textilný dizajn',
    textile_production: 'Textilná výroba',
    therapeutic_interventions: 'Terapeutické intervencie',
    therapy_planning: 'Plánovanie terapie',
    thermal_systems: 'Tepelné systémy',
    threading: 'Závitovanie',
    tig_welding: 'TIG zváranie',
    tile_installation: 'Inštalácia dlažby',
    tool_maintenance: 'Údržba náradia',
    tooling: 'Nástroje',
    tort_law: 'Deliktné právo',
    tour_guiding: 'Sprievodcovstvo',
    tourism_management: 'Riadenie cestovného ruchu',
    training_delivery: 'Realizácia školení',
    training_development: 'Vývoj školení',
    training_programs: 'Školiace programy',
    transaction_processing: 'Spracovanie transakcií',
    transmission_repair: 'Oprava prevodovky',
    transportation_management: 'Riadenie dopravy',
    travel_coordination: 'Koordinácia cestovania',
    travel_planning: 'Plánovanie cestovania',
    triage: 'Triedenie pacientov',
    troubleshooting: 'Riešenie problémov',
    turf_management: 'Správa trávnikov',
    turning: 'Sústruženie',
    tutoring: 'Doučovanie',
    typography: 'Typografia',
    ui_design: 'UI dizajn',
    ultrasound: 'Ultrazvuk',
    upholstery: 'Čalúnnictvo',
    user_experience: 'Užívateľská skúsenosť',
    user_interface: 'Používateľské rozhranie',
    user_training: 'Školenie používateľov',
    utility_systems: 'Inžinierske siete',
    ux_design: 'UX dizajn',
    vaccination: 'Očkovanie',
    valve_maintenance: 'Údržba ventilov',
    vendor_management: 'Správa dodávateľov',
    ventilation: 'Vetranie',
    ventilation_systems: 'Vetracie systémy',
    version_control: 'Verziovanie',
    veterinary_medicine: 'Veterinárna medicína',
    veterinary_nursing: 'Veterinárne ošetrovateľstvo',
    veterinary_surgery: 'Veterinárna chirurgia',
    video_production: 'Video produkcia',
    vineyard_management: 'Riadenie viníc',
    virtual_reality: 'Virtuálna realita',
    vision_testing: 'Testovanie zraku',
    visual_arts: 'Výtvarné umenie',
    visual_communication: 'Vizuálna komunikácia',
    visual_design: 'Vizuálny dizajn',
    visual_merchandising: 'Vizuálny merchandising',
    vocabulary_development: 'Rozvoj slovnej zásoby',
    volunteer_management: 'Riadenie dobrovoľníkov',
    warehouse_operations: 'Skladové operácie',
    waste_disposal: 'Likvidácia odpadu',
    waste_management: 'Správa odpadu',
    wastewater_treatment: 'Čistenie odpadových vôd',
    water_quality: 'Kvalita vody',
    water_systems: 'Vodovodné systémy',
    water_treatment: 'Úprava vody',
    web_design: 'Webový dizajn',
    wedding_planning: 'Plánovanie svadby',
    welding: 'Zváranie',
    welding_codes: 'Zváracie normy',
    wellness_programs: 'Wellness programy',
    wildlife_management: 'Správa voľne žijúcich živočíchov',
    wind_energy: 'Veterná energia',
    wine_production: 'Výroba vína',
    wiring: 'Elektroinstalácia',
    woodworking: 'Práca so drevom',
    workforce_development: 'Rozvoj pracovnej sily',
    workforce_planning: 'Plánovanie pracovnej sily',
    wound_care: 'Starostlivosť o rany',
    writing_skills: 'Písomné zručnosti',
    x_ray: 'Röntgen',
    xcode: 'Xcode',
    youth_development: 'Rozvoj mládeže',
    zoning_regulations: 'Územné predpisy',

    // Poľnohospodárstvo - Chýbajúce zručnosti
    breeding_programs: 'Šľachtiteľské programy',
    breeding_techniques: 'Techniky šľachtenia',
    chainsaw_operation: 'Obsluha motorovej píly',
    combine_harvester: 'Obsluha kombajnu',
    crop_cultivation: 'Pestovanie plodín',
    crop_planning: 'Plánovanie plodín',
    crop_science: 'Veda o plodinách',
    farm_management: 'Riadenie farmy',
    farm_software: 'Softvér pre farmárstvo',
    forest_inventory: 'Lesný inventár',
    forest_management: 'Lesné hospodárstvo',
    forest_protection: 'Ochrana lesa',
    forestry_planning: 'Plánovanie lesného hospodárstva',
    gis_mapping: 'GIS mapovanie',
    gps_guidance: 'GPS navigácia',
    harvesting_techniques: 'Techniky zberu úrody',
    irrigation_design: 'Návrh zavlažovania',
    milk_quality_testing: 'Testovanie kvality mlieka',
    milking_equipment: 'Dojárenské zariadenia',
    pest_identification: 'Identifikácia škodcov',
    plant_cultivation: 'Pestovanie rastlín',
    precision_agriculture: 'Precízne poľnohospodárstvo',
    pruning: 'Orezávanie',
    soil_testing: 'Testovanie pôdy',
    timber_estimation: 'Odhad dreva',
    timber_harvesting: 'Ťažba dreva',
    timber_measurement: 'Meranie dreva',
    tractor_operation: 'Obsluha traktora',
    tree_identification: 'Identifikácia stromov',

    // Automobilový priemysel - Chýbajúce zručnosti
    automotive_wiring: 'Automobilové elektroinštalácie',
    battery_systems: 'Batériové systémy',
    ecu_programming: 'Programovanie ECU',
    obd_diagnostics: 'OBD diagnostika',
    obd_scanner: 'OBD skener',
    vehicle_diagnostics: 'Diagnostika vozidiel',

    // Marketing & Obsah - Chýbajúce zručnosti
    binding_equipment: 'Väzbové zariadenia',
    cinematography: 'Kinematografia',
    cms: 'CMS',
    cms_platforms: 'CMS platformy',
    color_grading: 'Farebná korekcia',
    color_management: 'Správa farieb',
    color_mixing: 'Miešanie farieb',
    color_theory: 'Farebná teória',
    composition: 'Kompozícia',
    content_editing: 'Úprava obsahu',
    content_strategy: 'Obsahová stratégia',
    creative_design: 'Kreatívny dizajn',
    creative_software: 'Kreatívny softvér',
    creative_writing: 'Kreatívne písanie',
    digital_art: 'Digitálne umenie',
    editorial_leadership: 'Redakčné vedenie',
    editorial_management: 'Redakčný manažment',
    editorial_work: 'Redakčná práca',
    fact_checking: 'Overovanie faktov',
    grammar: 'Gramatika',
    journalism: 'Žurnalistika',
    lighting: 'Osvetlenie',
    lightroom: 'Lightroom',
    mixing_consoles: 'Miešacie pulty',
    multimedia_software: 'Multimediálny softvér',
    news_judgment: 'Novinársky úsudok',
    opinion_writing: 'Písanie názorov',
    printing_equipment: 'Tlačiarenské zariadenia',
    publishing_management: 'Riadenie publikovania',
    publishing_workflow: 'Publikačný workflow',
    recording_equipment: 'Nahrávacia technika',
    research: 'Výskum',
    sound_engineer: 'Zvukový inžinier',
    style_guides: 'Štýlové príručky',
    user_research: 'Používateľský výskum',

    // Logistika & Doprava - Chýbajúce zručnosti
    bus_driving: 'Vedenie autobusu',
    cargo_truck_driving: 'Vedenie nákladného auta',
    customs_documentation: 'Colná dokumentácia',
    customs_inspection: 'Colná kontrola',
    customs_procedures: 'Colné postupy',
    customs_software: 'Colný softvér',
    forklift_certification: 'Certifikácia na vysokozdvižný vozík',
    forklift_operation: 'Obsluha vysokozdvižného vozíka',
    freight_forwarding: 'Nákladná preprava',
    import_export_regulations: 'Predpisy o dovoze/vývoze',
    international_shipping: 'Medzinárodná preprava',
    load_handling: 'Manipulácia s nákladom',
    loading_unloading: 'Nakladanie/Vykladanie',
    logistics_control: 'Logistická kontrola',
    logistics_management: 'Logistický manažment',
    logistics_software: 'Logistický softvér',
    logistics_strategy: 'Logistická stratégia',
    material_handling: 'Manipulácia s materiálom',
    order_picking: 'Komisiovanie',
    package_handling: 'Manipulácia s balíkmi',
    shipping_documentation: 'Prepravná dokumentácia',
    shipping_procedures: 'Prepravné postupy',
    supply_chain_software: 'Softvér pre dodávateľský reťazec',
    tariff_classification: 'Tarifná klasifikácia',
    traffic_planning: 'Plánovanie dopravy',
    transportation_engineering: 'Dopravné inžinierstvo',
    transportation_planning: 'Plánovanie dopravy',
    warehouse_management_systems: 'Systémy riadenia skladov',
    delivery_driving: 'Rozvoz',
    delivery_services: 'Doručovacie služby',
    dispatch_operations: 'Dispečerské operácie',
    driving: 'Vedenie vozidla',
    fleet_software: 'Softvér pre správu vozového parku',
    gps_navigation: 'GPS navigácia',
    inventory_auditing: 'Audit zásob',
    inventory_systems: 'Systémy zásob',
    inventory_tracking: 'Sledovanie zásob',
    load_securing: 'Upevnenie nákladu',
    public_transport_driving: 'Vedenie verejnej dopravy',
    railway_operations: 'Železničné operácie',
    railway_systems: 'Železničné systémy',
    route_knowledge: 'Znalosti trás',
    route_optimization: 'Optimalizácia trás',
    stock_verification: 'Overenie zásob',
    train_operation: 'Obsluha vlaku',
    train_scheduling: 'Plánovanie vlakov',
    truck_driving: 'Vedenie nákladného vozidla',
    vehicle_inspection: 'Kontrola vozidla',
    vehicle_maintenance: 'Údržba vozidla',

    // Právo - Chýbajúce zručnosti
    authentication: 'Autentifikácia',
    case_law: 'Prípadové právo',
    case_management_software: 'Softvér pre správu prípadov',
    contract_management: 'Správa zmlúv',
    court_filing: 'Podávanie súdnych podaní',
    enforcement_procedures: 'Výkonné konanie',
    legal_databases: 'Právne databázy',
    legal_judgment: 'Právny úsudok',
    legal_knowledge: 'Právne znalosti',
    legal_management: 'Právny manažment',
    legal_procedures: 'Právne postupy',
    legal_software: 'Právny softvér',
    notarial_procedures: 'Notárske postupy',
    regulatory_databases: 'Regulačné databázy',
    regulatory_submissions: 'Regulačné podania',
    trial_management: 'Riadenie súdnych konaní',

    // HR & Mzdy - Chýbajúce zručnosti
    compensation_planning: 'Plánovanie odmeňovania',
    hr_systems: 'HR systémy',
    linkedin_recruiting: 'LinkedIn nábor',
    payroll_processing: 'Spracovanie miezd',
    payroll_software: 'Mzdový softvér',

    // Pohostinstvo & Kulinárstvo - Chýbajúce zručnosti
    baking: 'Pečenie',
    beverage_preparation: 'Príprava nápojov',
    cake_decoration: 'Zdobenie tort',
    check_in_out: 'Check-in/Check-out',
    coffee_preparation: 'Príprava kávy',
    confectionery: 'Cukrárstvo',
    cooking_techniques: 'Kuchárske techniky',
    culinary_techniques: 'Kulinárske techniky',
    dough_preparation: 'Príprava cesta',
    espresso_machines: 'Espresso kávovary',
    food_beverage_management: 'Riadenie stravovania a nápojov',
    food_beverage_pairing: 'Párovanie jedál a nápojov',
    food_chemistry: 'Chémia potravín',
    haccp: 'HACCP',
    hotel_management_software: 'Hotelový manažérsky softvér',
    kitchen_equipment: 'Kuchynské vybavenie',
    kitchen_management: 'Riadenie kuchyne',
    knife_skills: 'Práca s nožom',
    local_knowledge: 'Miestne znalosti',
    meat_cutting: 'Krájanie mäsa',
    meat_preparation: 'Príprava mäsa',
    menu_knowledge: 'Znalosti menu',
    mixology: 'Mixológia',
    oven_operation: 'Obsluha rúry',
    pastry_making: 'Výroba pečiva',
    pizza_making: 'Výroba pizze',
    pms_software: 'PMS softvér',
    recipe_following: 'Dodržiavanie receptov',
    table_service: 'Stolový servis',
    wine_knowledge: 'Znalosti vín',
    wine_pairing: 'Párovanie vín',

    // Zdravotníctvo & Medicína - Chýbajúce zručnosti
    basic_nursing: 'Základné ošetrovateľstvo',
    blood_analysis: 'Analýza krvi',
    casting: 'Sadrovanie',
    cell_culture: 'Bunkové kultúry',
    clinical_trials: 'Klinické skúšky',
    compounding: 'Zloženie liekov',
    ct_scan: 'CT vyšetrenie',
    delivery_assistance: 'Pomoc pri pôrode',
    dental_prosthetics: 'Zubné protézy',
    dental_software: 'Zubársky softvér',
    dental_surgery: 'Zubná chirurgia',
    dietary_guidelines: 'Stravovacie odporúčania',
    elisa: 'ELISA',
    emergency_medical_care: 'Urgentná zdravotná starostlivosť',
    epidemiology: 'Epidemiológia',
    eye_examination: 'Vyšetrenie zraku',
    gcp_compliance: 'GCP zhoda',
    health_programs: 'Zdravotné programy',
    hygiene_procedures: 'Hygienické postupy',
    hygiene_standards: 'Hygienické štandardy',
    laboratory_analysis: 'Laboratórna analýza',
    laboratory_diagnostics: 'Laboratórna diagnostika',
    laboratory_samples: 'Laboratórne vzorky',
    language_assessment: 'Jazykové hodnotenie',
    lens_fitting: 'Nasadenie šošoviek',
    life_support: 'Podpora života',
    massage_techniques: 'Masážne techniky',
    medical_advisor: 'Lékársky poradca',
    medical_auditing: 'Lékársky audit',
    medical_diagnosis: 'Lékárska diagnóza',
    medical_knowledge: 'Lékárske znalosti',
    medical_procedures: 'Lékárske postupy',
    medical_writing: 'Lékárske písanie',
    medication_administration: 'Podávanie liekov',
    medication_reminders: 'Pripomienky liekov',
    microscopy: 'Mikroskopia',
    mri: 'MRI',
    nursing_auditing: 'Ošetrovateľský audit',
    nursing_management: 'Ošetrovateľský manažment',
    nutrition_planning: 'Plánovanie výživy',
    obstetrics: 'Pôrodníctvo',
    optical_equipment: 'Optické zariadenia',
    optical_measurements: 'Optické merania',
    orthopedic_devices: 'Ortopedické pomôcky',
    pacs_systems: 'PACS systémy',
    pcr: 'PCR',
    pharmaceutical_analysis: 'Farmaceutická analýza',
    pharmaceutical_auditing: 'Farmaceutický audit',
    pharmaceutical_handling: 'Manipulácia s farmaceutikami',
    pharmaceutical_knowledge: 'Farmaceutické znalosti',
    pharmaceutical_products: 'Farmaceutické produkty',
    pharmacovigilance: 'Farmakovigilancia',
    pharmacy_software: 'Lekárenský softvér',
    prenatal_care: 'Predpôrodná starostlivosť',
    prescription_determination: 'Určenie receptu',
    prescription_verification: 'Overenie receptu',
    radiation_safety: 'Radiačná bezpečnosť',
    rehabilitation_techniques: 'Rehabilitačné techniky',
    splinting: 'Dlahovanie',
    therapeutic_exercises: 'Terapeutické cvičenia',
    therapeutic_massage: 'Terapeutická masáž',
    therapeutic_techniques: 'Terapeutické techniky',
    treatment_planning: 'Plánovanie liečby',
    urinalysis: 'Analýza moču',
    vital_signs_monitoring: 'Monitorovanie životných funkcií',
    x_ray_operation: 'Obsluha röntgenu',

    // Financie & Bankovníctvo - Chýbajúce zručnosti
    banking_operations: 'Bankové operácie',
    financial_advisory: 'Finančné poradenstvo',
    financial_instruments: 'Finančné nástroje',
    financial_markets: 'Finančné trhy',
    financial_mathematics: 'Finančná matematika',
    financial_products: 'Finančné produkty',
    investment_products: 'Investičné produkty',
    pricing_analysis: 'Analýza cien',
    banking_products: 'Bankové produkty',
    banking_software: 'Bankový softvér',
    claim_assessment: 'Posúdenie nárokov',
    collection_procedures: 'Inkasné procedúry',
    credit_assessment: 'Úverové hodnotenie',
    credit_scoring: 'Úverové skóring',
    insurance_operations: 'Poisťovacie operácie',
    insurance_products: 'Poisťovacie produkty',
    insurance_software: 'Poisťovací softvér',
    insurance_systems: 'Poisťovacie systémy',
    invoicing: 'Fakturácia',
    leasing_operations: 'Lízingové operácie',
    leasing_products: 'Lízingové produkty',
    lending_systems: 'Úverové systémy',
    mortgage_products: 'Hypotekárne produkty',
    payment_processing: 'Spracovanie platieb',
    policy_administration: 'Správa poistiek',
    policy_pricing: 'Oceňovanie poistiek',
    receivables_management: 'Správa pohľadávok',
    reconciliation: 'Zosúladenie',
    risk_evaluation: 'Hodnotenie rizík',
    risk_modeling: 'Modelovanie rizík',
    risk_software: 'Softvér pre riadenie rizík',
    settlement_procedures: 'Vyrovnávacie procedúry',
    swift_messaging: 'SWIFT správy',
    tax_compliance: 'Daňová zhoda',
    tax_software: 'Daňový softvér',
    trading_platforms: 'Obchodné platformy',
    transaction_verification: 'Overovanie transakcií',
    treasury_systems: 'Pokladničné systémy',
    underwriting_software: 'Softvér pre upisovanie',
    wealth_management: 'Správa majetku',

    // Životné prostredie & Vodohospodárstvo - Chýbajúce zručnosti
    eia: 'EIA (Hodnotenie vplyvu na životné prostredie)',
    environmental_assessment: 'Environmentálne hodnotenie',
    environmental_protection: 'Ochrana životného prostredia',
    environmental_regulations: 'Environmentálne predpisy',
    environmental_sampling: 'Environmentálne vzorkovanie',
    iso_14001: 'ISO 14001',
    pump_operation: 'Obsluha čerpadiel',
    water_chemistry: 'Chémia vody',
    water_engineering: 'Vodohospodárske inžinierstvo',
    water_quality_testing: 'Testovanie kvality vody',

    // Elektrotechnika & Elektronika - Chýbajúce zručnosti
    automation: 'Automatizácia',
    circuit_design: 'Návrh obvodov',
    circuit_simulation: 'Simulácia obvodov',
    circuit_testing: 'Testovanie obvodov',
    electrical_safety: 'Elektrická bezpečnosť',
    electrical_wiring: 'Elektrické vedenie',
    electronics_troubleshooting: 'Riešenie problémov s elektronikou',
    ladder_logic: 'Rebrčíková logika',
    scada_systems: 'SCADA systémy',
    testing_equipment: 'Testovacie zariadenia',

    // Vzdelávanie & Školenie - Chýbajúce zručnosti
    behavior_management: 'Riadenie správania',
    behavioral_management: 'Behaviorálny manažment',
    classroom_support: 'Podpora v triede',
    course_design: 'Návrh kurzov',
    curriculum_planning: 'Plánovanie učebných osnov',
    driving_instruction: 'Výučba jazdy',
    early_childhood_education: 'Vzdelávanie v ranom detstve',
    individualized_education_plans: 'Individuálne vzdelávacie plány',
    lms_platforms: 'LMS platformy',
    practical_instruction: 'Praktická výučba',
    scorm: 'SCORM',
    student_assistance: 'Pomoc študentom',
    student_mentoring: 'Mentorovanie študentov',
    teaching_methods: 'Vyučovacie metódy',
    traffic_regulations: 'Dopravné predpisy',
    training_techniques: 'Školiace techniky',
    university_teaching: 'Univerzitná výučba',
    vehicle_operation: 'Ovládanie vozidla',
    vocational_training: 'Odborné vzdelávanie',
    workshop_management: 'Riadenie workshopov',

    // Siete & Telekomunikácie - Chýbajúce zručnosti
    backup_procedures: 'Zálohovacie procedúry',
    bss_systems: 'BSS systémy',
    cctv_installation: 'Inštalácia CCTV',
    cisco_networking: 'Cisco siete',
    coverage_planning: 'Plánovanie pokrytia',
    cybersecurity: 'Kybernetická bezpečnosť',
    fiber_optics: 'Optické vlákna',
    fraud_detection: 'Detekcia podvodov',
    incident_response: 'Reakcia na incidenty',
    lte_5g: 'LTE/5G',
    mobile_networks: 'Mobilné siete',
    network_modeling: 'Modelovanie sietí',
    network_operations: 'Sieťové operácie',
    network_planning: 'Plánovanie sietí',
    network_testing: 'Testovanie sietí',
    oss_systems: 'OSS systémy',
    penetration_testing: 'Penetračné testovanie',
    radio_network_optimization: 'Optimalizácia rádiových sietí',
    radio_network_planning: 'Plánovanie rádiových sietí',
    rf_engineering: 'RF inžinierstvo',
    rf_planning: 'RF plánovanie',
    routing_switching: 'Smerovanie & Prepínanie',
    signal_testing: 'Testovanie signálu',
    tcp_ip: 'TCP/IP',
    telecommunications_equipment: 'Telekomunikačné zariadenia',
    telecommunications_installation: 'Telekomunikačná inštalácia',
    user_management: 'Správa používateľov',
    virtualization: 'Virtualizácia',
    windows_server: 'Windows Server',

    // Databáza - Chýbajúce zručnosti
    backup_recovery: 'Zálohovanie & Obnova',
    data_modeling: 'Dátové modelovanie',
    database_optimization: 'Optimalizácia databázy',
    query_optimization: 'Optimalizácia dopytov',
    replication: 'Replikácia',
    sql: 'SQL',
    sql_optimization: 'SQL optimalizácia',

    // Veda & Výskum - Chýbajúce zručnosti
    cataloging: 'Katalogizácia',
    chromatography: 'Chromatografia',
    culture_methods: 'Kultivačné metódy',
    flow_cytometry: 'Prietoková cytometria',
    gc_ms: 'GC-MS',
    geodesy: 'Geodézia',
    geospatial_analysis: 'Geopriestorová analýza',
    hplc: 'HPLC',
    information_retrieval: 'Vyhľadávanie informácií',
    mass_spectrometry: 'Hmotnostná spektrometria',
    mathematical_modeling: 'Matematické modelovanie',
    measurement_standards: 'Meracie štandardy',
    metrology: 'Metrológia',
    molecular_biology: 'Molekulárna biológia',
    research_methods: 'Výskumné metódy',
    scientific_writing: 'Vedecké písanie',
    sterile_techniques: 'Sterilné techniky',
    western_blot: 'Western blot',

    // Stavebníctvo & Výstavba - Chýbajúce zručnosti
    building_management: 'Správa budov',
    construction_economics: 'Stavebná ekonomika',
    construction_planning: 'Plánovanie výstavby',
    construction_processes: 'Stavebné procesy',
    construction_software: 'Stavebný softvér',
    construction_supervision: 'Stavebný dohľad',
    construction_technology: 'Stavebná technológia',
    drywall_installation: 'Inštalácia sadrokartónu',
    electrical_design: 'Návrh elektrických systémov',
    excavators: 'Rýpadlá',
    fem_software: 'FEM softvér',
    flooring_installation: 'Inštalácia podláh',
    glass_calibration: 'Kalibrácia skla',
    glass_cutting: 'Rezanie skla',
    heavy_machinery: 'Ťažké stroje',
    insulation_installation: 'Inštalácia izolácie',
    joinery: 'Stolárstvo',
    leak_detection: 'Detekcia úniku',
    load_calculations: 'Výpočty zaťaženia',
    mep_design: 'MEP návrh',
    mortar_mixing: 'Miešanie malty',
    pipe_fitting: 'Montáž potrubí',
    pipe_installation: 'Inštalácia potrubí',
    plumbing_design: 'Návrh inštalácií',
    quantity_takeoff: 'Výmer množstva',
    rigging: 'Montáž a upevňovanie',
    roofing_installation: 'Inštalácia strechy',
    safety_management: 'Riadenie bezpečnosti',
    scaffolding_erection: 'Stavanie lešenia',
    sheet_metal_work: 'Plechárske práce',
    structural_knowledge: 'Znalosti statiky',
    taping_finishing: 'Bandážovanie a finálne úpravy',
    tile_setting: 'Kladenie obkladov',
    window_installation: 'Inštalácia okien',
    windshield_replacement: 'Výmena čelného skla',
    wood_cutting: 'Rezanie dreva',

    // Marketing & Komunikácia - Ďalšie chýbajúce zručnosti
    basic_analytics: 'Základná analytika',
    branding: 'Branding',
    campaign_development: 'Vývoj kampaní',
    campaign_strategy: 'Stratégia kampaní',
    communication_platforms: 'Komunikačné platformy',
    community_management: 'Správa komunity',
    content_optimization: 'Optimalizácia obsahu',
    crisis_communication: 'Krízová komunikácia',
    event_management: 'Riadenie udalostí',
    internal_communications: 'Interná komunikácia',
    keyword_research: 'Výskum kľúčových slov',
    marketing_campaigns: 'Marketingové kampane',
    marketing_knowledge: 'Marketingové znalosti',
    marketing_management: 'Marketingový manažment',
    marketing_strategy: 'Marketingová stratégia',
    marketing_support: 'Marketingová podpora',
    media_buying: 'Nákup médií',
    media_planning: 'Plánovanie médií',
    media_software: 'Mediálny softvér',
    online_marketing: 'Online marketing',
    ppc_campaigns: 'PPC kampane',
    press_releases: 'Tlačové správy',
    social_media: 'Sociálne médiá',
    social_media_advertising: 'Reklama na sociálnych médiách',
    social_media_platforms: 'Platformy sociálnych médií',
    technical_seo: 'Technické SEO',
    vendor_coordination: 'Koordinácia dodávateľov',

    // Verejná správa & Poštové služby - Chýbajúce zručnosti
    citizen_services: 'Služby pre občanov',
    mail_delivery: 'Doručovanie pošty',
    policy_implementation: 'Implementácia politík',
    postal_regulations: 'Poštové predpisy',
    procurement_law: 'Zákon o verejnom obstarávaní',
    public_administration: 'Verejná správa',
    public_procurement: 'Verejné obstarávanie',
    regulatory_procedures: 'Regulačné postupy',
    senior_advisory: 'Senior poradenstvo',
    senior_policy_advice: 'Senior politické poradenstvo',
    sorting: 'Triedenie',
    tender_procedures: 'Verejné súťaže',

    // Rôzne profesionálne zručnosti - Chýbajúce zručnosti (Časť 1)
    avionics: 'Avionika',
    basic_cooking: 'Základné varenie',
    basic_equipment: 'Základné zariadenia',
    basic_math: 'Základná matematika',
    basic_mechanics: 'Základná mechanika',
    basic_patient_care: 'Základná starostlivosť o pacientov',
    basic_repairs: 'Základné opravy',
    basic_skills: 'Základné zručnosti',
    basic_technology: 'Základné technológie',
    basic_tools: 'Základné nástroje',
    beauty_treatments: 'Kozmetické ošetrenia',
    beverage_presentation: 'Prezentácia nápojov',
    blacksmithing: 'Kováčstvo',
    blasting: 'Pieskanie',
    bodywork_alignment: 'Nastavenie karosérie',
    boiler_operation: 'Obsluha kotlov',
    cabin_service: 'Kabínová služba',
    cable_installation: 'Inštalácia káblov',
    call_center_management: 'Riadenie call centra',
    call_center_operations: 'Operácie call centra',
    call_center_software: 'Call center softvér',
    call_routing: 'Smerovanie hovorov',
    canvas_preparation: 'Príprava plátna',
    casino_games: 'Kasínové hry',
    cat_tools: 'CAT nástroje',
    chemical_safety: 'Chemická bezpečnosť',
    childcare: 'Starostlivosť o deti',
    choreography: 'Choreografia',
    cleaning: 'Upratovanie',
    cleaning_equipment: 'Upratovacie zariadenia',
    client_advisory: 'Poradenstvo pre klientov',
    client_assessment: 'Hodnotenie klientov',
    client_consultation: 'Konzultácia s klientmi',
    client_relationship: 'Vzťahy s klientmi',
    coaching_methods: 'Koučovacie metódy',
    communication_systems: 'Komunikačné systémy',
    communications: 'Komunikácia',
    complaint_handling: 'Vybavovanie sťažností',
    complaint_management: 'Riadenie sťažností',
    cooperative_management: 'Riadenie družstva',
    country_management: 'Krajinský manažment',
    craftsmanship: 'Remeselná zručnosť',
    crew_management: 'Riadenie posádky',

    // Obchodný manažment & Plánovanie - Chýbajúce zručnosti
    business_development: 'Obchodný rozvoj',
    business_planning: 'Obchodné plánovanie',
    business_processes: 'Obchodné procesy',
    capacity_planning: 'Plánovanie kapacity',
    cmms_systems: 'CMMS systémy',
    coordination: 'Koordinácia',
    demand_planning: 'Plánovanie dopytu',
    erp_systems: 'ERP systémy',
    facility_systems: 'Systémy zariadení',
    kpi_tracking: 'Sledovanie KPI',
    maintenance_coordination: 'Koordinácia údržby',
    maintenance_management: 'Riadenie údržby',
    performance_analysis: 'Analýza výkonu',
    performance_metrics: 'Metriky výkonu',
    performance_tracking: 'Sledovanie výkonu',
    process_analysis: 'Analýza procesov',
    process_management: 'Riadenie procesov',
    product_management: 'Produktový manažment',
    purchasing_software: 'Nákupný softvér',
    requirement_analysis: 'Analýza požiadaviek',
    requirement_gathering: 'Zber požiadaviek',
    roadmap_planning: 'Plánovanie roadmap',
    sprint_planning: 'Plánovanie sprintov',
    supply_management: 'Riadenie dodávok',
    system_analysis: 'Systémová analýza',
    vendor_negotiation: 'Vyjednávanie s dodávateľmi',
    vendor_relations: 'Vzťahy s dodávateľmi',

    // Technické & Vývoj - Chýbajúce zručnosti
    bug_tracking: 'Sledovanie chýb',
    cocoa_touch: 'Cocoa Touch',
    composer: 'Composer',
    data_processing: 'Spracovanie údajov',
    debugging: 'Ladenie',
    expert_knowledge: 'Expertné znalosti',
    integration_patterns: 'Integračné vzory',
    junit: 'JUnit',
    markdown: 'Markdown',
    maven: 'Maven',
    microservices: 'Mikroslužby',
    pytest: 'PyTest',
    selenium: 'Selenium',
    system_architecture: 'Systémová architektúra',
    technical_consultation: 'Technická konzultácia',
    test_automation: 'Automatizácia testovania',
    test_cases: 'Testovacie prípady',
    testing: 'Testovanie',
    user_manuals: 'Používateľské príručky',

    // Rôzne profesionálne zručnosti - Chýbajúce zručnosti (Časť 3)
    consecutive_interpreting: 'Konzekutívne tlmočenie',
    cooking: 'Varenie',
    cutting_equipment: 'Rezovacie zariadenia',
    cutting_tools: 'Rezovacie nástroje',
    design_principles: 'Princípy dizajnu',
    dmx_control: 'DMX ovládanie',
    finishing: 'Dokončovanie',
    forging: 'Kovanie',
    fuel_dispensing: 'Výdaj paliva',
    fur_working: 'Práca s kožušinami',
    gemstone_setting: 'Osadzovanie drahokamov',
    geology: 'Geológia',
    gps_surveying: 'GPS prieskum',
    guest_reception: 'Prijímanie hostí',
    hydrology: 'Hydrológia',
    ic_design: 'Návrh integrovaných obvodov',
    inspection_techniques: 'Inšpekčné techniky',
    modeling: 'Modelovanie',
    monitoring_control: 'Monitorovanie a kontrola',
    monitoring_equipment: 'Monitorovacie zariadenia',
    monitoring_visits: 'Monitorovacie návštevy',
    pedicure: 'Pedikúra',
    precision_tools: 'Presné nástroje',
    pressure_testing: 'Tlakové testovanie',
    production_procedures: 'Výrobné postupy',
    production_supervision: 'Supervízia výroby',
    semiconductor_technology: 'Polovodičová technológia',
    service_monitoring: 'Monitorovanie služieb',
    speed_efficiency: 'Rýchlosť a efektívnosť',
    styling: 'Styling',
    time_studies: 'Časové štúdie',
    tire_mounting: 'Montáž pneumatík',
    tire_pressure_monitoring: 'Monitorovanie tlaku v pneumatikách',
    tools_equipment: 'Nástroje a zariadenia',
    tpms_systems: 'TPMS systémy',
    upholstery_techniques: 'Čalúnické techniky',
    vhdl_verilog: 'VHDL/Verilog',
    wig_styling: 'Styling parochní',
    wood_engineering: 'Drevárske inžinierstvo',
    wood_processing: 'Spracovanie dreva',
    wood_product_design: 'Dizajn drevených produktov',
    wood_technology: 'Drevárska technológia',

    // Rôzne profesionálne zručnosti - Chýbajúce zručnosti (Časť 2)
    consulting: 'Poradenstvo',
    consulting_methods: 'Metódy poradenstva',
    correspondence: 'Korešpondencia',
    counseling_techniques: 'Techniky poradenstva',
    cultural_management: 'Kultúrny manažment',
    cultural_programs: 'Kultúrne programy',
    current_affairs: 'Aktuálne dianie',
    customer_advisory: 'Poradenstvo pre zákazníkov',
    customer_communication: 'Komunikácia so zákazníkmi',
    customer_consultation: 'Konzultácia so zákazníkmi',
    customer_verification: 'Overovanie zákazníkov',
    dance_techniques: 'Tanečné techniky',
    data_recording: 'Zaznamenávanie údajov',
    data_verification: 'Overovanie údajov',
    dealing_techniques: 'Techniky vyjednávania',
    dent_removal: 'Odstránenie preliačin',
    destination_knowledge: 'Znalosti destinácií',
    detailing: 'Detailing',
    diagnostic_tools: 'Diagnostické nástroje',
    dishwashing: 'Umývanie riadu',
    documentation: 'Dokumentácia',
    donor_management: 'Riadenie donorov',
    ecological_surveying: 'Ekologický prieskum',
    economic_analysis: 'Ekonomická analýza',
    email_management: 'Správa e-mailov',
    english_translation: 'Anglický preklad',
    entertainment_programs: 'Zábavné programy',
    equipment_handling: 'Manipulácia so zariadením',
    event_decoration: 'Dekorácia podujatí',
    exercise_programs: 'Cvičebné programy',
    fabric_knowledge: 'Znalosti textílií',
    fashion_knowledge: 'Módne znalosti',
    fashion_software: 'Módny softvér',
    fem_analysis: 'FEM analýza',
    fitness_training: 'Fitness tréning',
    floor_care: 'Starostlivosť o podlahy',
    floral_design: 'Dizajn kvetov',
    flower_arranging: 'Aranžovanie kvetov',
    following_instructions: 'Dodržiavanie pokynov',
    frame_selection: 'Výber rámov',
    front_desk_operations: 'Operácie na recepcii',
    front_desk_software: 'Recepčný softvér',
    fur_treatment: 'Úprava kožušín',
    furniture_making: 'Výroba nábytku',
    furniture_repair: 'Oprava nábytku',
    gaming_regulations: 'Herné predpisy',
    geological_knowledge: 'Geologické znalosti',
    geological_surveying: 'Geologický prieskum',
    german_translation: 'Nemecký preklad',
    hair_coloring: 'Farbenie vlasov',
    haircutting: 'Strihanie vlasov',
    handyman_skills: 'Zručnosti údržbára',
    hardware_support: 'Hardvérová podpora',
    height_work: 'Práca vo výškach',
    household_management: 'Správa domácnosti',
    hydraulic_design: 'Hydraulický návrh',
    hygiene_care: 'Hygienická starostlivosť',
    installation: 'Inštalácia',
    instrument_proficiency: 'Ovládanie nástrojov',
    itinerary_planning: 'Plánovanie itinerárov',
    kitchen_cleaning: 'Čistenie kuchyne',
    knowledge_base: 'Znalostná báza',
    labeling: 'Označovanie',
    land_surveying: 'Geodézia',
    language_proficiency: 'Jazyková zdatnosť',
    language_skills: 'Jazykové zručnosti',
    laundry: 'Práčovňa',
    leather_working: 'Práca s kožou',
    licensing_compliance: 'Dodržiavanie licencií',
    literacy_review: 'Kontrola gramotnosti',
    maintenance: 'Údržba',
    makeup_techniques: 'Techniky líčenia',
    manicure: 'Manikúra',
    manual_labor: 'Manuálna práca',
    maritime_regulations: 'Námorné predpisy',
    materials_knowledge: 'Znalosti materiálov',
    mathematics: 'Matematika',
    measurement: 'Meranie',
    mechanical_knowledge: 'Mechanické znalosti',
    mechatronics: 'Mechatronika',
    meeting_minutes: 'Zápisnica zo stretnutia',
    metadata_cataloging: 'Katalogizácia metadát',
    mining_equipment: 'Banícke zariadenie',
    mining_operations: 'Banícke operácie',
    mixed_media: 'Zmiešané médiá',
    mobility_assistance: 'Pomoc s mobilitou',
    nail_care: 'Starostlivosť o nechty',
    navigation_equipment: 'Navigačné zariadenie',
    note_taking: 'Vytváranie poznámok',
    nutrition_basics: 'Základy výživy',
    optimization: 'Optimalizácia',
    packaging_equipment: 'Baliace zariadenie',
    packaging_procedures: 'Baliace postupy',
    paint_booth_operation: 'Obsluha lakovne',
    painting_techniques: 'Techniky maľovania',
    panel_beating: 'Karosárstvo',
    paper_handling: 'Manipulácia s papierom',
    patient_transport: 'Transport pacientov',
    pattern_cutting: 'Strihanie vzorov',
    performance: 'Výkon',
    personal_hygiene: 'Osobná hygiena',
    persuasive_writing: 'Presvedčivé písanie',
    phone_systems: 'Telefónne systémy',
    physical_stamina: 'Fyzická vytrvalosť',
    plant_knowledge: 'Znalosti rastlín',
    polishing_machines: 'Leštičky',
    preservation_techniques: 'Techniky konzervácie',
    pressure_washer: 'Vysokotlaková čistiaca stroj',
    problem_resolution: 'Riešenie problémov',
    process_simulation: 'Simulácia procesov',
    production_standards: 'Výrobné štandardy',
    productivity_standards: 'Štandardy produktivity',
    program_development: 'Vývoj programov',
    property_care: 'Starostlivosť o majetok',
    quality_sorting: 'Triedenie kvality',
    registry_procedures: 'Registračné postupy',
    remote_desktop: 'Vzdialená plocha',
    reporting: 'Reportovanie',
    reservation_management: 'Správa rezervácií',
    reservation_procedures: 'Rezervačné postupy',
    robot_programming: 'Programovanie robotov',
    rope_access: 'Lanový prístup',
    salon_equipment: 'Salónové vybavenie',
    sawmill_operation: 'Obsluha píly',
    scanning_systems: 'Skenovacie systémy',
    scenic_design: 'Scénický dizajn',
    sealant_application: 'Aplikácia tesniacich hmôt',
    seating_coordination: 'Koordinácia sedenia',
    sewing_machines: 'Šijacie stroje',
    ship_navigation: 'Lodná navigácia',
    shoe_making: 'Výroba obuvi',
    signal_recognition: 'Rozpoznávanie signálov',
    simulation_software: 'Simulačný softvér',
    simulation_tools: 'Simulačné nástroje',
    simultaneous_interpreting: 'Simultánne tlmočenie',
    sociological_research: 'Sociologický výskum',
    sop_compliance: 'Dodržiavanie SOP',
    special_effects: 'Špeciálne efekty',
    sports_training: 'Športový tréning',
    staff_management: 'Riadenie personálu',
    stage_presence: 'Scénická prezentácia',
    standard_setting: 'Nastavovanie štandardov',
    statistical_methods: 'Štatistické metódy',
    statistical_software: 'Štatistický softvér',
    styling_software: 'Styling softvér',
    switchboard_operation: 'Obsluha ústredne',
    team_facilitation: 'Facilitácia tímu',
    team_supervision: 'Supervízia tímu',
    technical_analysis: 'Technická analýza',
    technical_calculations: 'Technické výpočty',
    technical_expertise: 'Technická expertíza',
    technical_knowledge: 'Technické znalosti',
    technical_management: 'Technický manažment',
    technical_procedures: 'Technické postupy',
    technical_processes: 'Technické procesy',
    technical_specifications: 'Technické špecifikácie',
    technical_troubleshooting: 'Technické riešenie problémov',
    temperature_control: 'Regulácia teploty',
    terminology_management: 'Správa terminológie',
    theater_technology: 'Divadelná technika',
    ticketing_systems: 'Systémy predaja vstupeniek',
    total_station: 'Totálna stanica',
    travel_booking_systems: 'Systémy rezervácie cestovania',
    trend_analysis: 'Analýza trendov',
    trend_awareness: 'Povedomie o trendoch',
    verification_procedures: 'Overové postupy',
    vocal_techniques: 'Vokálne techniky',
    wardrobe_management: 'Správa šatníka',
    watch_repair: 'Oprava hodiniek',
    wheel_balancing: 'Vyvažovanie kolies',
    work_measurement: 'Meranie práce',
    workflow_planning: 'Plánovanie pracovných tokov',

    // Predaj & Maloobchodný manažment - Chýbajúce zručnosti
    display_design: 'Dizajn výkladu',
    e_commerce_platforms: 'E-commerce platformy',
    key_account_management: 'Správa kľúčových účtov',
    phone_communication: 'Telefonická komunikácia',
    product_expertise: 'Znalosti produktov',
    product_placement: 'Umiestnenie produktov',
    product_presentation: 'Prezentácia produktov',
    product_promotion: 'Propagácia produktov',
    regional_management: 'Regionálny manažment',
    retail_knowledge: 'Znalosti maloobchodu',
    sales_analysis: 'Analýza predaja',
    sales_coaching: 'Koučovanie predaja',
    sales_management: 'Riadenie predaja',
    sales_strategy: 'Predajná stratégia',
    sales_support: 'Podpora predaja',
    sales_targets: 'Predajné ciele',
    sales_techniques: 'Predajné techniky',
    section_management: 'Riadenie sekcie',
    specialized_sales: 'Špecializovaný predaj',
    store_management: 'Riadenie predajne',
    store_operations: 'Prevádzka predajne',
    telemarketing: 'Telemarketing',
    territory_management: 'Správa územia',
    upselling: 'Doplnkový predaj',
    visual_displays: 'Vizuálne výklady',

    // Bezpečnosť, Ochrana & Záchranné služby - Chýbajúce zručnosti
    emergency_planning: 'Plánovanie núdzových situácií',
    fire_codes: 'Požiarne predpisy',
    fire_prevention: 'Prevencia požiarov',
    fire_safety_systems: 'Požiarne bezpečnostné systémy',
    firearms_handling: 'Manipulácia so strelnou zbraňou',
    firefighting_equipment: 'Hasičské zariadenie',
    hazmat_procedures: 'HAZMAT postupy',
    investigation_techniques: 'Vyšetrovacie techniky',
    law_enforcement: 'Presadzovanie zákona',
    military_operations: 'Vojenské operácie',
    military_tactics: 'Vojenské taktiky',
    navigation: 'Navigácia',
    patrol_procedures: 'Postupy hliadkovania',
    physical_training: 'Fyzický tréning',
    rescue_techniques: 'Záchranné techniky',
    safety_analysis: 'Bezpečnostná analýza',
    safety_inspection: 'Bezpečnostná inšpekcia',
    safety_standards: 'Bezpečnostné normy',
    security_management: 'Riadenie bezpečnosti',
    security_procedures: 'Bezpečnostné postupy',
    surveillance: 'Dohľad',
    swimming: 'Plávanie',
    tactics: 'Taktiky',
    water_safety: 'Bezpečnosť na vode',
    weapons_handling: 'Manipulácia so zbraňami',

    // Výroba & Riadenie kvality - Chýbajúce zručnosti
    calipers_micrometers: 'Posuvné meradlá & Mikrometre',
    cmm_operation: 'Obsluha CMM',
    defect_analysis: 'Analýza chýb',
    foundry_equipment: 'Zlievarne zariadenia',
    grinding_machines: 'Brúsne stroje',
    iso_standards: 'ISO normy',
    lean_manufacturing: 'Lean výroba',
    machine_calibration: 'Kalibrácia strojov',
    material_science: 'Materiálová veda',
    material_testing: 'Testovanie materiálov',
    measurement_tools: 'Meracie nástroje',
    metal_casting: 'Liatie kovov',
    metallurgical_processes: 'Metalurgické procesy',
    metallurgy: 'Metalurgia',
    milling_machines: 'Frézovačky',
    mold_making: 'Výroba foriem',
    ndt_methods: 'NDT metódy',
    production_machinery: 'Výrobné stroje',
    production_management: 'Riadenie výroby',
    quality_monitoring: 'Monitorovanie kvality',
    quality_software: 'Softvér pre riadenie kvality',
    six_sigma: 'Six Sigma',
    statistical_process_control: 'Štatistické riadenie procesov',
    tool_changing: 'Výmena nástrojov',
    tool_making: 'Výroba nástrojov',
    tool_setup: 'Nastavenie nástrojov',
    turning_machines: 'Sústruhy',
    ultrasonic_testing: 'Ultrazvukové testovanie',
  },
};
